<div class="card" (click)="redirectTo()" [class.disabled]="data.disabled" [class.highlight]="data.highlight">
  <div class="img-wrapper" *ngIf="data.img">
    <img src="../../../assets/actualite.png" alt="actu" />
  </div>

  <div class="icon-wrapper relative" *ngIf="data.bigIcon">
    <ion-icon [name]="data.bigIcon" class="text-2xl"></ion-icon>
    <ion-badge
    *ngIf="data.badge && data.badge > 0"
    color="danger"
    class="text-sm rounded-full px-2 py-1 absolute top-0 left-0 translate-x-[+50%] translate-y-[+50%]" 
  >
    {{ data.badge }}
  </ion-badge>
  </div>

  <div class="right">
      <h2 class="text-lg font-medium">{{ data.title }}</h2>


    <p>{{ data.subtitle1 }}</p>
    <p *ngIf="data.subtitle2">{{ data.subtitle2 }}</p>

    <div class="sponsored" *ngIf="data.sponsored">Sponsorisé</div>
  </div>

  <ion-button shape="round" size="small" *ngIf="!data.disabled">
    <ion-icon slot="icon-only" [name]="data.icon" class="text-2xl"></ion-icon>
  </ion-button>
</div>
